// Odeslání invokace akce zpět do legacy okna (Phoenix → Magic `window/action`).
// Cílí konkrétní iframe podle layerId přes registr okno↔layerId.

import { legacyFormSourceRegistry, PHOENIX_TO_MAGIC_ACTIONS } from '@/shared/legacyMagicBridge';

export function sendWindowAction(layerId: string, actionId: string): void {
  const target = legacyFormSourceRegistry.resolveWindow(layerId);
  if (!target) return;
  target.postMessage(
    {
      action: PHOENIX_TO_MAGIC_ACTIONS.windowAction,
      data: { actionId },
      requestId: crypto.randomUUID(),
    },
    '*'
  );
}
